import { render, staticRenderFns } from "./TestPractice.vue?vue&type=template&id=6bd6ddb5&scoped=true&"
import script from "./TestPractice.vue?vue&type=script&lang=js&"
export * from "./TestPractice.vue?vue&type=script&lang=js&"
import style0 from "./TestPractice.vue?vue&type=style&index=0&id=6bd6ddb5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd6ddb5",
  null
  
)

export default component.exports